import { useApiConfig } from '../useApiConfig';

import { IAS_PROJECTS_QUERY_KEY } from '../../utils/consts';
import { useQueryClient } from '@tanstack/react-query';
import { InfrastructureInstancesApi } from 'osep-generator-service-client-v1';

function useDeleteInfraInstanceMutation() {
  const { getApiConfig, axiosInstance } = useApiConfig();
  const queryClient = useQueryClient();

  const deleteInfraInstance = async (id: string) => {
    const config = await getApiConfig();
    const api = new InfrastructureInstancesApi(
      config,
      undefined,
      axiosInstance,
    );

    const response = await api.deleteInfrastructureInstance(id);
    await queryClient.invalidateQueries({
      predicate: (query) => query.queryKey.includes(IAS_PROJECTS_QUERY_KEY),
    });

    return response.data;
  };

  return { deleteInfraInstance };
}

export default useDeleteInfraInstanceMutation;
